"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable import/prefer-default-export, camelcase */
var rest_1 = __importDefault(require("../../../rest"));
var tournamentsApi_1 = require("../../mock/learningPanel/tournamentsApi");
var tournamentsServiceUrl = process.env.CB_SERVER_URL;
var TournamentsAPIs = {
    getUpcomingTournaments: function (token) {
        return rest_1.default.get({
            mockFunc: function () { return tournamentsApi_1.mockUpcomingTournaments; },
            url: "".concat(tournamentsServiceUrl, "/learning-panel/upcoming-tournaments"),
            token: token,
        });
    },
    getPastTournaments: function (token) {
        return rest_1.default.get({
            mockFunc: function () { return tournamentsApi_1.mockPastTournaments; },
            url: "".concat(tournamentsServiceUrl, "/learning-panel/past-tournaments"),
            token: token,
        });
    },
    getTournamentUsersLeaderboard: function (token, offset, limit, tournamentUuid, searchString) {
        return rest_1.default.get({
            mockFunc: function () { return tournamentsApi_1.mockTournamentLeaderboardUsers; },
            url: "".concat(tournamentsServiceUrl, "/learning-panel/leaderboard/").concat(tournamentUuid, "?limit=").concat(limit, "&offset=").concat(offset, "&search_string=").concat(searchString || ''),
            token: token,
        });
    },
    getTournamentResults: function (token, tournamentUuid) {
        return rest_1.default.get({
            mockFunc: function () { return tournamentsApi_1.mockTournamentResults; },
            url: "".concat(tournamentsServiceUrl, "/learning-panel/user-results/").concat(tournamentUuid),
            token: token,
        });
    },
};
exports.default = TournamentsAPIs;
